import {
    ViewListingExpandableSectionWrapper,
    ViewListingExpandableSectionTitle,
    ViewListingExpandableSectionSubtitle,
    ViewListingExpandableSectionContainerCancel,
    ViewListingDamageDepositText,
    ViewListingDamageDepositLink,
} from "../viewListingStyling";
import { getSimpleCancellationPolicyText } from "../../../utils/cancellationPolicy";
import { isHotel } from "../../../utils/listingUtils";

interface ViewListingExpandableCancellationSectionProps {
    cancellationPolicy: string;
    title: string;
    listingId: string;
    dates: {
        startDate: string | Date;
        endDate: string | Date;
    };
}

export default function ViewListingExpandableCancellationSection({ cancellationPolicy, title, listingId, dates }: ViewListingExpandableCancellationSectionProps) {
    const getText = () => {
        if (isHotel(listingId)) {
            const hasDates = dates.startDate && dates.startDate !== "anyArrival" && dates.endDate && dates.endDate !== "anyDeparture";
            
            return (
                <ViewListingDamageDepositText style={{ margin: 0 }}>
                    {hasDates 
                        ? "Please check the room policy for cancellation details. "
                        : "Please select your dates to see the cancellation policy for your stay. "
                    }
                    <ViewListingDamageDepositLink href="https://help.anystay.com/en/articles/7007340-cancellations" target="_blank">
                        Learn more
                    </ViewListingDamageDepositLink>
                </ViewListingDamageDepositText>
            );
        }

        const policyText = getSimpleCancellationPolicyText(cancellationPolicy);
        if (!policyText) return "";
        
        return (
            <ViewListingDamageDepositText style={{ margin: 0 }}>
                {policyText}{" "}
                <ViewListingDamageDepositLink href="https://help.anystay.com/en/articles/7007340-cancellations" target="_blank">
                    Learn more
                </ViewListingDamageDepositLink>
            </ViewListingDamageDepositText>
        );
    };

    return (
        <ViewListingExpandableSectionContainerCancel>
            <ViewListingExpandableSectionWrapper>
                <ViewListingExpandableSectionTitle>{title}</ViewListingExpandableSectionTitle>
            </ViewListingExpandableSectionWrapper>
            <ViewListingExpandableSectionSubtitle style={{ marginTop: "8px" }}>{getText()}</ViewListingExpandableSectionSubtitle>
        </ViewListingExpandableSectionContainerCancel>
    );
}
